import React, { useState } from 'react';
import { StyleSheet, Text, TouchableOpacity } from 'react-native';
import { luxColors, Modal, Iffy, DNABox, DNAText } from '@alucio/lux-ui';
import VirtualModal from '../../VirtualModal/VirtualModal';
const styles = StyleSheet.create({
    backdrop: {
        backgroundColor: luxColors.modalBackdrop.primary,
    },
    internationalNumberText: {
        color: luxColors.info.primary,
        fontSize: 15,
    },
    modalContentText: {
        color: luxColors.info.primary,
        fontSize: 15,
        lineHeight: 48,
        opacity: 0.5,
    },
    tinyMarginTop: {
        marginTop: 4,
    },
    dialNumber: {
        color: luxColors.info.primary,
        fontSize: 24,
        fontWeight: 'bold',
        lineHeight: 32,
        marginBottom: 5,
    },
});
function DialInModal(props) {
    const { accessCode, dialInNumbers, isShown, onClose, localPhoneAudio } = props;
    const [displayInternationalNumbers, setDisplayInternationalNumbers] = useState(false);
    const modalHeaderText = localPhoneAudio ? 'Use Computer Audio' : 'Call-In Instructions';
    function onDisplayInternationalNumbers() {
        setDisplayInternationalNumbers((display) => !display);
    }
    return (React.createElement(Modal, { visible: isShown, backdropStyle: styles.backdrop },
        React.createElement(VirtualModal, { width: 500, headerText: modalHeaderText, onClose: onClose },
            React.createElement(DNABox, { appearance: "col", alignX: "start", alignY: "start" },
                React.createElement(Iffy, { is: localPhoneAudio },
                    React.createElement(Text, { style: styles.modalContentText }, "Please hang up your phone to use computer audio.")),
                React.createElement(Iffy, { is: !localPhoneAudio },
                    React.createElement(Text, { style: styles.modalContentText }, "1. On your phone, dial:"),
                    React.createElement(Text, { style: styles.dialNumber }, dialInNumbers.US),
                    React.createElement(Iffy, { is: displayInternationalNumbers },
                        React.createElement(DNABox, { appearance: "col", spacing: "small" }, Object.keys(dialInNumbers).filter((country) => country !== 'US').map((country, idx) => (React.createElement(Text, { key: idx, style: styles.internationalNumberText },
                            dialInNumbers[country],
                            " (",
                            country,
                            ")"))))),
                    React.createElement(TouchableOpacity, { onPress: onDisplayInternationalNumbers, style: styles.tinyMarginTop },
                        React.createElement(DNAText, { b2: true, status: "primary" },
                            displayInternationalNumbers
                                ? 'Hide'
                                : 'View',
                            " international numbers")),
                    React.createElement(Text, { style: styles.modalContentText }, "2. Enter this access code when prompted:"),
                    React.createElement(Text, { style: styles.dialNumber }, accessCode))))));
}
export default DialInModal;
//# sourceMappingURL=DialInModal.js.map